import { render, staticRenderFns } from "./organization-file-pending-approval.vue?vue&type=template&id=bd6786be&scoped=true"
import script from "./organization-file-pending-approval.vue?vue&type=script&lang=js"
export * from "./organization-file-pending-approval.vue?vue&type=script&lang=js"
import style0 from "./organization-file-pending-approval.vue?vue&type=style&index=0&id=bd6786be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6786be",
  null
  
)

export default component.exports